// Mock data pro Fabrikov web

export const contactInfo = {
  email: 'info@fabrikov.cz',
  phone: '+420 608 803 556',
  address: {
    street: 'Žitavská 916',
    city: 'Frýdlant',
    zip: '464 01'
  }
};

export const services = [
  {
    id: 'metalwork',
    title: 'Zakázková kovovýroba',
    description: 'Profesionální zpracování kovu na míru vašim potřebám. Specializujeme se na precizní svařování, CNC obrábění a výrobu kovových konstrukcí.',
    image: 'https://images.unsplash.com/photo-1714504904786-b6732390b206',
    uses: [
      'Kovové konstrukce a rámy',
      'Svařované díly a sestavy',
      'CNC soustružení a frézování',
      'Přesné opracování kovů',
      'Renovace a opravy'
    ]
  },
  {
    id: '3d-print',
    title: '3D tisk',
    description: 'Rychlá výroba prototypů a funkčních dílů pomocí moderních 3D tiskáren. Od návrhu po finální výrobek.',
    image: 'https://images.unsplash.com/photo-1752614672115-adcf3e2596af',
    uses: [
      'Prototypy a funkční modely',
      'Náhradní díly',
      'Designové komponenty',
      'Přípravky a formy',
      'Vizualizace projektů'
    ]
  },
  {
    id: 'laser-engraving',
    title: 'Laserové gravírování',
    description: 'Precizní gravírování do kovů, plastů a dalších materiálů. Personalizace, značení a dekorativní úpravy.',
    image: 'https://images.unsplash.com/photo-1739850269293-8ed949c32b22',
    uses: [
      'Personalizované dárky',
      'Označení výrobků a nářadí',
      'Reklamní předměty',
      'Štítky a tabulky',
      'Umělecké gravury'
    ]
  }
];

export const gallery = [
  {
    id: 1,
    image: 'https://images.unsplash.com/photo-1745448797900-35d08e85e9db',
    title: 'Svařování ocelových konstrukcí',
    description: 'Precizní svařování pomocí MIG/MAG technologie'
  },
  {
    id: 2,
    image: 'https://images.unsplash.com/photo-1531053326607-9d349096d887',
    title: 'Výroba kovových rámů',
    description: 'Zakázková výroba rámových konstrukcí'
  },
  {
    id: 3,
    image: 'https://images.pexels.com/photos/5845969/pexels-photo-5845969.jpeg',
    title: 'TIG svařování',
    description: 'Kvalitní TIG svary pro náročné aplikace'
  },
  {
    id: 4,
    image: 'https://images.unsplash.com/photo-1549563316-5384a923453e',
    title: '3D tištěné prototypy',
    description: 'Rychlá výroba funkčních prototypů'
  },
  {
    id: 5,
    image: 'https://images.unsplash.com/photo-1662735142465-c443674e0390',
    title: 'Laserové gravírování',
    description: 'Detailní gravírování do různých materiálů'
  },
  {
    id: 6,
    image: 'https://images.unsplash.com/photo-1747999461210-a56f72294428',
    title: 'Broušení a finishing',
    description: 'Konečná úprava a dokončení povrchů'
  },
  {
    id: 7,
    image: 'https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122',
    title: 'Přesné obrábění',
    description: 'CNC obrábění s vysokou přesností'
  },
  {
    id: 8,
    image: 'https://images.unsplash.com/photo-1529479627062-5f1f0b88912a',
    title: 'Úprava kovových dílů',
    description: 'Profesionální zpracování kovů'
  },
  {
    id: 9,
    image: 'https://images.pexels.com/photos/5845964/pexels-photo-5845964.jpeg',
    title: 'Zakázková výroba',
    description: 'Individuální řešení pro každého zákazníka'
  }
];

export const aboutText = {
  headline: 'Kvalita a preciznost na prvním místě',
  paragraphs: [
    'Jsme rodinná firma z Frýdlantu, která se zabývá zakázkovou kovovýrobou, 3D tiskem a laserovým gravírováním. Naše práce je založena na individuálním přístupu ke každému zákazníkovi a důrazu na kvalitu zpracování.',
    'Díky modernímu vybavení dílny a dlouholetým zkušenostem dokážeme realizovat projekty od drobných oprav až po komplexní zakázky. Každý výrobek vyrábíme s maximální péčí a přesností.',
    'Nabízíme kompletní servis od konzultace, přes návrh a výrobu až po finální montáž. Vaše spokojenost je naší prioritou.'
  ]
};

// Skutečné odeslání kontaktního formuláře přes Resend backend
import axios from 'axios';

export const submitContactForm = async (formData) => {
  const { data } = await axios.post('/api/contact', formData);
  return data;
};
